import { Filter, Interval } from '@elderbyte/ngx-starter'
import { Instant } from '@js-joda/core'
import { MexusViewMode } from '../../context/view-mode-context/mexus-view-mode'

export class UtilisationFilterBuilder {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public static readonly VIEW_MODE_KEY = 'viewMode'
  public static readonly SCHEDULE_INTERVAL_KEY = 'scheduleInterval'
  public static readonly TIMESTAMP_KEY = 'timestamp'

  private _viewMode: MexusViewMode
  private _scheduleInterval: Interval
  private _timestamp: Instant

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static start(): UtilisationFilterBuilder {
    return new UtilisationFilterBuilder()
  }

  public static viewMode(viewMode: MexusViewMode): Filter {
    return this.start().viewMode(viewMode).build()[0]
  }

  public static scheduleInterval(interval: Interval): Filter {
    return this.start().scheduleInterval(interval).build()[0]
  }

  public static timestamp(timestamp: Instant): Filter {
    return this.start().timestamp(timestamp).build()[0]
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public viewMode(viewMode: MexusViewMode): UtilisationFilterBuilder {
    this._viewMode = viewMode
    return this
  }

  public scheduleInterval(scheduleInterval: Interval): UtilisationFilterBuilder {
    this._scheduleInterval = scheduleInterval
    return this
  }

  public timestamp(instant: Instant): UtilisationFilterBuilder {
    this._timestamp = instant
    return this
  }

  public build(): Filter[] {
    const filters: Filter[] = []

    if (this._viewMode) {
      filters.push(new Filter(UtilisationFilterBuilder.VIEW_MODE_KEY, this._viewMode))
    }

    if (this._scheduleInterval) {
      filters.push(
        new Filter(
          UtilisationFilterBuilder.SCHEDULE_INTERVAL_KEY,
          this._scheduleInterval.toInstantString()
        )
      )
    }

    if (this._timestamp) {
      filters.push(new Filter(UtilisationFilterBuilder.TIMESTAMP_KEY, this._timestamp.toString()))
    }

    return filters
  }
}
